interface State {
    lineupsData: any;
    lateSwap: any;
}

class LineupsStorage {
    constructor(private state: State) {}
    getLateswapLineupViewByEntryId(entryId: string): object | null {
        // @ts-ignore
        const {
            lateSwap: {simplexLineups, lineupViews},
        } = this.state;

        const simplexLineup = simplexLineups.getOneByEntryId(entryId);

        if (!simplexLineup) {
            return null;
        }

        return lineupViews.getOneByLineupId(simplexLineup.getId());
    }
    getLateswapLineupViewByGeneratedLineupId(lineupId: string): object | null {
        // @ts-ignore
        const {
            lineupsData: {rawLineups},
            lateSwap: {simplexLineups},
        } = this.state;

        if (!simplexLineups.hasLineups()) {
            return null;
        }

        const rawLineup = rawLineups.getLineup(lineupId);

        return this.getLateswapLineupViewByEntryId(rawLineup.getEntryId());
    }
}

function createLineupsStorage(state: State): LineupsStorage {
    return new LineupsStorage(state);
}

export {createLineupsStorage};
